import React from 'react';
import { PayedBy } from '../../../../shared/Constants';
import InsufficientCreditsForRetentionFeePaidBySelf from './InsufficientCreditsForRetentionFeePaidBySelf';
import InsufficientCreditsForRetentionFeePaidByParent from './InsufficientCreditsForRetentionFeePaidByParent';

const InsufficientCreditsForRetentionFee = ({ visible, insufficientCreditsData }) => {
  const { payedBy } = insufficientCreditsData;

  if (payedBy === PayedBy.PAYED_BY_SELF) {
    return (
      <InsufficientCreditsForRetentionFeePaidBySelf
        visible={visible}
        insufficientCreditsData={insufficientCreditsData}
      />
    );
  }

  if (payedBy === PayedBy.PAYED_BY_PARENT) {
    return (
      <InsufficientCreditsForRetentionFeePaidByParent
        visible={visible}
        insufficientCreditsData={insufficientCreditsData}
      />
    );
  }

  return null;
};

export default InsufficientCreditsForRetentionFee;
